<ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
    <ng-template #viewWindowContent let-defaultTemplate>
        <ntap-prime-popupview appendTo="body">
            <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
        </ntap-prime-popupview>
    </ng-template>
</ntap-view-window>
<ng-container ntapViewItemProvider>
    <app-ntap-list [inplaceEditing]="true" [quickDataEntry]="true" [quickDataEntryInputs]="fastEntryInputs$" ></app-ntap-list>
</ng-container>